import React from 'react';
import { Provider } from 'react-redux';
import { createRoot } from 'react-dom/client';
import './shared/global';
import './components-styles/globalStyles.css';
import store from './global-state/redux';
import App from './App';
import reportWebVitals from './reportWebVitals';
import SeqLogger from './global-utils/seqLogger';
import { detectAdminPreview } from './shared/admin-preview';
import { RemoteControl } from './features/remote-control';
import { fetchAppConfig, fetchCore } from './features/boot';

detectAdminPreview(window.location.href);
const container = document.getElementById('vmRevolutionRoot');
const root = createRoot(container);

// Keep <RemoteControl/> outside redux provider to spare remote control processing on store updates
fetchCore().then(fetchAppConfig).then(() => root.render(
  <>
    <RemoteControl />
    <Provider store={store}>
      <App />
    </Provider>
  </>
));

reportWebVitals((item) => {
  const duration = (
    Math.round(item.name === 'CLS' ? item.delta * 1000 : item.delta) / 1000
  ).toFixed(2);
  const message = '{name} logged with {duration}s';
  SeqLogger.emit({
    messageTemplate: message,
    level: 'Information',
    properties: {
      name: item.name,
      duration
    }
  });
});
